class CustomProductGallery {
  constructor() {
    this.gallery = document.querySelector(".section__content");
    this.images = this.gallery?.querySelectorAll(".section__image img");
    this.modal = null;
    this.currentIndex = 0;

    this.init();
  }

  init() {
    if (!this.images?.length) return;

    this.createModal();
    this.bindEvents();
  }

  createModal() {
    this.modal = document.createElement("div");
    this.modal.className = "gallery-modal";
    this.modal.innerHTML = `
      <div class="gallery-modal__content">
        <button class="gallery-modal__close">&times;</button>
        <button class="gallery-modal__prev">&lt;</button>
        <button class="gallery-modal__next">&gt;</button>
        <div class="gallery-modal__image-container"></div>
      </div>
    `;
    document.body.appendChild(this.modal);
  }

  bindEvents() {
    this.images.forEach((img, index) => {
      img.style.cursor = "pointer";
      img.addEventListener("click", () => this.openGallery(index));
    });

    this.modal
      .querySelector(".gallery-modal__close")
      .addEventListener("click", () => this.closeGallery());
    this.modal
      .querySelector(".gallery-modal__prev")
      .addEventListener("click", () => this.showPrev());
    this.modal
      .querySelector(".gallery-modal__next")
      .addEventListener("click", () => this.showNext());

    document.addEventListener("keydown", (e) => {
      if (!this.modal.classList.contains("is-visible")) return;

      if (e.key === "Escape") this.closeGallery();
      if (e.key === "ArrowLeft") this.showPrev();
      if (e.key === "ArrowRight") this.showNext();
    });
  }

  openGallery(index) {
    this.currentIndex = index;
    this.updateModalImage();
    this.modal.classList.add("is-visible");
    document.body.style.overflow = "hidden";
  }

  closeGallery() {
    this.modal.classList.remove("is-visible");
    document.body.style.overflow = "";
  }

  showPrev() {
    this.currentIndex =
      (this.currentIndex - 1 + this.images.length) % this.images.length;
    this.updateModalImage();
  }

  showNext() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.updateModalImage();
  }

  updateModalImage() {
    const container = this.modal.querySelector(
      ".gallery-modal__image-container"
    );
    const currentImage = this.images[this.currentIndex];

    container.innerHTML = `
      <img src="${currentImage.src}" alt="${currentImage.alt}" />
      <div class="gallery-modal__description">${currentImage.nextElementSibling.textContent}</div>
    `;
  }
}

// Initialize gallery when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new CustomProductGallery();
});
